import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Pressable,
} from 'react-native';
import {Color, globalFontStyle} from '../assets';
import Colors from '../assets/Color/Colors';
import FastImage from '../common/FastImage';
import {isMobile} from '../utils/commonMethods';
import {globalConfigurableData, GlobalScreens} from '../utils/globalConstant';
import { convert } from "../locale/translateText";
import {
  gift,
  smile_coin_black,
  smile_coin_no,
  smile_coin_white,
  smile_coin_yes,
} from '../utils/images';

const btnMap = {
  yes: 'yesBtn',
  yesInactive: 'yesBtnInactive',
  noInactive: 'noBtnInactive',
  no: 'noBtn',
  normalBlue: 'normalBlue',
  disable: 'disabled',
  yellow: 'btnYellow',
  red: 'btnRed',
  rmLiquidity: 'rmLiquidity',
  mergeShare: 'mergeShare',
  btnGrey: 'btnGrey',
  btnBlack: 'btnBlack',
  btnBlackInactive: 'btnBlackInactive',
  btnBlue: 'btnBlue',
  disableBlack: 'disableBlack',
  btnBlackNew: 'btnBlackNew',
  disableBlackNew: 'disableBlackNew',
  blackBorderedButton: 'blackBorderedButton',
  btnBlackWhite: 'btnBlackWhite',
};
const btnInternalText = {
  yes: 'yesBtnText',
  yesInactive: 'yesBtnInactiveText',
  noInactive: 'noBtnInactiveText',
  no: 'noBtnText',
  disable: 'disabledText',
  yellow: 'btnYellowText',
  rmLiquidity: 'rmLiquidityText',
  mergeShare: 'mergeShareText',
  btnGrey: 'btnGreyText',
  btnBlack: 'btnBlackTextWhite',
  disableBlack: 'btnBlackTextWhite',
  btnBlackInactive: 'btnBlackTextWhite',
  btnBlue: 'btnBlue',
  btnBlackNew: 'btnBlackText',
  disableBlackNew: 'btnBlackDisableText',
  blackBorderedButton: 'btnBlackText',
  btnBlackWhite: 'btnBlackWhiteText',
};
const CustomButton = ({
  btnText,
  btnType,
  onBtnClick,
  customStyle = {},
  isDisable = false,
  isImageInBtn = false,
  isImageInBtnLeft,
  isSubText,
  translate = false,
  returnsVar,
  customFontStyle = {},
  isSmileEvent,
}) => {
  const stylee = btnMap[btnType];
  const styleText = btnInternalText[btnType];
  return (
    <TouchableOpacity
      onPressIn={onBtnClick}
      delayPressIn={0}
      disabled={isDisable}
      activeOpacity={0.8}
      style={[
        styles.commonBtnStyle,
        styles[stylee],
        isSubText ? {paddingVertical: 12} : null,
        customStyle,
      ]}>
      {isImageInBtnLeft ? (
        <FastImage
          style={{width: 18, height: 18, marginRight: 3}}
          source={isImageInBtnLeft()}
        />
      ) : null}
      <Text
        style={[
          globalFontStyle.appFontBody,
          styles.fontStyle,
          styles[styleText],
          customFontStyle,
        ]}>
        {translate ? convert(btnText) : btnText}
      </Text>
      {isSubText ? (
        <View style={{flexDirection: 'row', gap: 2, alignItems: 'center'}}>
          <Text
            style={[
              globalFontStyle.appFontSmallText,
              styles.fontStyle,
              styles[styleText],
            ]}
          >
            {translate ? convert(isSubText) : isSubText}
          </Text>
          {isSmileEvent && (
            <FastImage
              style={{width: 12, height: 12, marginRight: 2}}
              source={
                btnType === 'yes' || btnType === 'yesInactive'
                  ? smile_coin_yes()
                  : smile_coin_no()
              }
            />
          )}
          <Text
            style={[
              globalFontStyle.appFontSmallText,
              styles.fontStyle,
              styles[styleText],
            ]}>
            {returnsVar?.returnsVar}
          </Text>
        </View>
      ) : null}
      {isImageInBtn ? (
        <FastImage
          style={{width: 18, height: 18}}
          source={globalConfigurableData?.gift()}
        />
      ) : null}
    </TouchableOpacity>
  );
};

export default CustomButton;

const styles = StyleSheet.create({
  commonBtnStyle: {
    paddingVertical: isMobile() ? 18 : 14,
    flex: 1,
    alignItems: 'center',
    borderRadius: globalConfigurableData.btnBorderRadius,
  },
  fontStyle: {
    color: Color.bgWhite,
  },
  btnGrey: {
    backgroundColor: globalConfigurableData.greyBtnColor,
  },
  btnGreyText: {
    color: globalConfigurableData.greyBtnTxt,
  },
  yesBtn: {
    borderRadius: globalConfigurableData.btnBorderRadius,
    backgroundColor: globalConfigurableData.yesBtnBlock,
  },
  noBtn: {
    borderRadius: globalConfigurableData.btnBorderRadius,
    backgroundColor: globalConfigurableData.noBtnBlock,
  },
  btnBlackTextWhite: {
    color: globalConfigurableData.primaryBtnTxt,
  },
  btnBlackDisableText: {
    color: globalConfigurableData.disableBtnTextColor,
  },
  yesBtnText: {
    color: globalConfigurableData.yesBtnTxt,
  },
  noBtnText: {
    color: globalConfigurableData.noBtnTxt,
  },
  yesBtnInactive: {
    backgroundColor: globalConfigurableData.yesBtnBlockInactive,
  },
  noBtnInactive: {
    backgroundColor: globalConfigurableData.noBtnBlockInactive,
  },
  yesBtnInactiveText: {
    color: globalConfigurableData.yesBtnBlockInactiveTxt,
  },
  noBtnInactiveText: {
    color: globalConfigurableData.noBtnBlockInactiveTxt,
  },
  rmLiquidity: {
    backgroundColor: globalConfigurableData.yesBtnBlockInactive,
  },
  rmLiquidityText: {
    color: globalConfigurableData.yesBtnBlockInactiveTxt,
  },
  mergeShare: {
    backgroundColor: globalConfigurableData.noBtnBlockInactive,
  },
  mergeShareText: {
    color: globalConfigurableData.noBtnBlockInactiveTxt,
  },
  btnBlack: {
    backgroundColor: globalConfigurableData.secondaryBtnColor,
    borderRadius: 8,
  },

  btnBlackWhite: {
    color: '#000000',
    ...globalFontStyle.appFontBody,
  },
  disableBlack: {
    backgroundColor: Color.grey7,
  },
  btnBlackNew: {
    backgroundColor: Color.bgWhite,
    borderColor: Color.black,
    borderWidth: 1,
    paddingVertical: isMobile() ? 17 : 13,
  },
  disableBlackNew: {
    backgroundColor: globalConfigurableData.disableBtnColor,
    borderColor: Color.black,
    borderWidth: 1,
    paddingVertical: isMobile() ? 17 : 13,
    opacity: 0.5,
  },
  btnBlue: {
    backgroundColor: globalConfigurableData.primaryBtnColor,
  },
  btnBlackWhiteText: {
    color: Color.black,
  },
  btnBlackText: {
    color: globalConfigurableData.primaryTextColor1,
  },
  normalBlue: {
    backgroundColor: globalConfigurableData.primaryBtnColor,
  },
  disabled: {
    backgroundColor: 'rgba(80, 55, 191, 0.50)',
  },
  disabledText: {
    color: Colors.bgWhite,
  },
  btnBlackInactive: {
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
  },
  blackBorderedButton: {
    borderRadius: 8,
    borderColor: GlobalScreens.AddMoney.borderColor,
    backgroundColor: globalConfigurableData.globalThemeColor,
    color: globalConfigurableData.primaryTextColor1,
    borderWidth: 1,
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  btnYellow: {
    backgroundColor: '#ffe600',
  },
  btnYellowText: {
    color: Color.black,
  },
  btnRed: {
    backgroundColor: '#FF3739',
  },
});
